import { render, staticRenderFns } from "./PdpSidebar.vue?vue&type=template&id=49f83a4c&scoped=true"
import script from "./PdpSidebar.vue?vue&type=script&lang=js"
export * from "./PdpSidebar.vue?vue&type=script&lang=js"
import style0 from "./PdpSidebar.vue?vue&type=style&index=0&id=49f83a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f83a4c",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fproduct-details-26%2Fsubcomponents%2Fpdp-sidebar%2FPdpSidebar.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports